export default __webpack_public_path__ + "static/media/info-circle-blue.7adbfe1f.svg";